const dashboard = {
    page_title: 'Dashboard',
    eyebrow: 'Identity',
    title: 'Identity console',
    description: 'Manage applications, access, sign-in, and identity operations.',
    search_placeholder: 'Search identity settings',
    workspace_controls: 'Identity controls',
    workspace_controls_description: 'A live snapshot of this identity workspace and the controls available to your role.',
    role_filtered: 'Role filtered',
    no_results: 'No matching identity controls.',
    card_descriptions: {
        dashboard: 'Return to the Identity Console home.',
        applications: 'Register apps, machine clients, and protected apps.',
        sign_in_experience: 'Brand the sign-in flow and account experience.',
        mfa: 'Require stronger verification for sensitive access.',
        connectors: 'Configure email, SMS, social, and enterprise providers.',
        enterprise_sso: 'Connect external identity providers for organizations.',
        security: 'Manage password policy, CAPTCHA, blocklist, and security defaults.',
        api_resources: 'Define APIs, scopes, and Management API access.',
        roles: 'Assign permissions to users and machine clients.',
        organization_template: 'Set default organization roles and permissions.',
        organizations: 'Model customers, workspaces, and membership boundaries.',
        users: 'Create users, review profiles, and manage access.',
        customize_jwt: 'Customize claims for application and API tokens.',
        webhooks: 'Send identity events to operational systems.',
        audit_logs: 'Review identity events and operational changes.',
        tenant_settings: 'Manage tenant profile, domains, members, and OIDC settings.',
    },
    groups: {
        authentication: 'Authentication',
        user_access: 'User access',
        developer_operations: 'Developer operations',
    },
    snapshot: {
        members: 'Members',
        applications: 'Applications',
        api_resources: 'API resources',
        roles: 'Roles',
        sso_connections: 'SSO connections',
    },
    key_areas: {
        title: 'Key areas',
        applications: {
            title: 'Applications',
            description: 'Register apps, machine clients, and protected apps.',
        },
        sign_in: {
            title: 'Sign-in & account',
            description: 'Brand the sign-in flow and account experience.',
        },
        enterprise_sso: {
            title: 'Enterprise SSO',
            description: 'Connect external identity providers for organizations.',
        },
        users: {
            title: 'User management',
            description: 'Create users, review profiles, and manage access.',
        },
        api_resources: {
            title: 'API resources',
            description: 'Define APIs, scopes, and Management API access.',
        },
    },
    controls: {
        mfa: {
            title: 'Multi-factor auth',
            description: 'Require stronger verification for sensitive access.',
        },
        organizations: {
            title: 'Organizations',
            description: 'Model customers, workspaces, and membership boundaries.',
        },
        roles: {
            title: 'Roles',
            description: 'Assign permissions to users and machine clients.',
        },
        organization_template: {
            title: 'Organization template',
            description: 'Set default organization roles and permissions.',
        },
        webhooks: {
            title: 'Webhooks',
            description: 'Send identity events to operational systems.',
        },
        custom_jwt: {
            title: 'Custom JWT',
            description: 'Customize claims for application and API tokens.',
        },
    },
    activity_title: 'User activity',
    activity_description: 'Real sign-in and token activity from this identity workspace.',
    total_users: 'Total users',
    total_users_tip: 'Total users',
    new_users_today: 'New users today',
    new_users_today_tip: 'The number of new users registered on your apps today',
    new_users_7_days: 'New users past 7 days',
    new_users_7_days_tip: 'The number of new users registered on your apps in the past 7 days',
    daily_active_users: 'Daily active users',
    daily_active_users_tip: 'The number of unique users exchanged tokens on your apps today',
    weekly_active_users: 'Weekly active users',
    weekly_active_users_tip: 'The number of unique users exchanged tokens on your apps in the past 7 days',
    monthly_active_users: 'Monthly active users',
    monthly_active_users_tip: 'The number of unique users exchanged tokens on your apps in the past 30 days',
};
export default Object.freeze(dashboard);
